import userAgent from '@/utilities/userAgent'

let currentWidth = window.innerWidth

/**
 * 画面幅の変化をチェックする
 *
 * @return { boolean } true: 画面幅変化有り false: 画面幅変化無し
 */
export default async function() {
  // 画面幅の変化をチェック
  const oldWidth = currentWidth

  // ios は resize 後に window width が変化するため少し待つ
  if (userAgent.isIos()) {
    await new Promise(resolve => setTimeout(resolve, 50))
  }

  currentWidth = window.innerWidth

  return oldWidth !== currentWidth
}
